import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, ElementRef } from '@angular/core';
import { CurrentUserService, UserRoles } from '../services/current-user.service';
  
@Directive({
    selector: '[appEnableForRoles]'
})

export class AllowedRoleDirective implements OnInit {
    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private currentUserService: CurrentUserService
    ) {}

    private allowedRoles: UserRoles;

    @Input() set appEnableForRoles(allowedRoles: UserRoles) {
        this.allowedRoles = allowedRoles;
    }

    ngOnInit() {
        this.currentUserService.get()
            .subscribe(user => {
                if (user.roles & this.allowedRoles) {
                    this.viewContainer.createEmbeddedView(this.templateRef);
                } else {
                    this.viewContainer.clear();
                }
            }
        )
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/directives/allowed-role.directive.ts